import { Switch } from "@mui/material";
import { useContext, useState } from "react";
import { ThemeKind, ThemeKindContext } from "../../app/theme";

function ThemeSwitch() {
  const context = useContext(ThemeKindContext);
  const [checked, setChecked] = useState(context.kind === ThemeKind.Dark);

  const handleClick = () => {
    const newChecked = !checked;
    context.setThemeKind(newChecked ? ThemeKind.Dark : ThemeKind.Light);
    setChecked(newChecked);
  };

  return <Switch checked={checked} onClick={handleClick} color="default" />;
}

export default ThemeSwitch;
